import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment'
import transferencia from './transferencia';

const state = {
    id: 0,
    // fechaContable: moment(new Date()).format('YYYY-MM-DD'),
    personalId: 0,
    personal: {},
    personalNombre: null,
    ingresoEgresoTipoId: 0,
    ingresoEgresoTipo: null,
    ingresoEgresoTipoNombre: null,
    observaciones: '',

    cuotas: [],
    importeCuotas: 0,
    cuotasEnabled: false,

    /* Documentos */
    pesos: 0,
    importeTransferencias: 0,
    transferencias: [],
    transferenciasEnabled: false,
    importeDepositos: 0,
    depositos: [],
    depositosEnabled: false,
    // importeChequesTerceros: 0,
    // chequesTerceros: [],

    /* Caja */
    cajaRegistroId: 0,
    cajaRegistro: null,
    cajaRegistroNombre: null,

    ingresoEgresoDatos: [],
    ingresoEgresoCuotasDatos: [],
    ingresoEgresoDocumentos: [],
    ingresoEgresoDepositos: [],
    ingresoEgresoTransferencias: [],
    
    ingresoEgresoDatosRpt: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_INGRESO_EGRESO' (state) {
        state.id = 0;
        // state.fechaContable = moment(new Date()).format('YYYY-MM-DD'),
        state.personalId= 0;
        state.personal= null;
        state.personalNombre= null;
        state.ingresoEgresoTipoId= 0;
        state.ingresoEgresoTipo= null;
        state.ingresoEgresoTipoNombre= null;
        state.observaciones = '';
        
        state.cuotas = [];
        state.importeCuotas = 0;
        state.cuotasEnabled = false;

        state.cajaRegistro = null;
        state.cajaRegistroId = 0;
        state.cajaRegistroNombre = null;

        state.transferenciasEnabled = false;
        state.depositosEnabled = false;

        inicializarDocumentos(state);
    },
    'SET_PERSONAL'(state, personal) {
        state.personal = personal;
        if (personal) {
            state.personalId = personal.id? personal.id : 0;
            state.personalNombre = personal.nombre? personal.nombre.trim() : null;
        } else {
            state.personalId = 0;
            state.personalNombre = null;
        }
    },
    'SET_INGRESO_EGRESO_TIPO'(state, ingresoEgresoTipo) {
        state.ingresoEgresoTipo = ingresoEgresoTipo;
        if (ingresoEgresoTipo) {
            state.ingresoEgresoTipoId = ingresoEgresoTipo.id? ingresoEgresoTipo.id : 0;
            state.ingresoEgresoTipoNombre = ingresoEgresoTipo.nombre? ingresoEgresoTipo.nombre.trim() : null;
        } else {
            state.ingresoEgresoTipoId = 0;
            state.ingresoEgresoTipoNombre = null;
        }

        state.cuotas = [];
        state.importeCuotas = 0;
        /* Adelantos */
        state.cuotasEnabled = state.ingresoEgresoTipoId == 3;

        state.transferenciasEnabled = false;
        state.depositosEnabled = false;

        inicializarDocumentos(state);
        
        switch (state.ingresoEgresoTipoId) {
            case 1: /* Aportes */
            case 7: /* Aportes de Socios */
                state.transferenciasEnabled = true;
                state.depositosEnabled = true;
                break;
        
            case 2: /* Retiros */
            case 3: /* Adelantos de sueldo */
            case 5: /* Devolucion de viaticos */
            case 6: /* Retiros de Socios */
                state.transferenciasEnabled = true;
                state.depositosEnabled = false;
                break;
        }
    },
    'ADD_CUOTA' (state, cuota) {
        state.cuotas.push(cuota);

        if (state.cuotas.lenght != 0) {
            state.importeCuotas = state.cuotas
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeCuotas = 0;
        }
    },
    'DELETE_CUOTA' (state, cuota) {
        let itemKey = state.cuotas
            .findIndex(item => item == cuota);

        if (itemKey != -1) {
            state.cuotas.splice(itemKey, 1);
        }

        if (state.cuotas.lenght != 0) {
            state.importeCuotas = state.cuotas
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeCuotas = 0;
        }
    },
    'SET_CAJA_REGISTRO' (state, cajaRegistro) {
        state.cajaRegistro = cajaRegistro;
        state.cajaRegistroId = 0;
        state.cajaRegistroNombre = null;
        if (cajaRegistro) {
            if (cajaRegistro.id) {
                state.cajaRegistroId = cajaRegistro.id;
            }
            if (cajaRegistro.nombre) {
                state.cajaRegistroNombre = cajaRegistro.nombre.toUpperCase().trim();
            }
        }
    },
    'SET_DEPOSITO' (state, deposito) {
        state.depositos.push(deposito);

        if (state.depositos.lenght != 0) {
            state.importeDepositos = state.depositos
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeDepositos = 0;
        }
    },
    'DELETE_DEPOSITO' (state, deposito) {
        let itemKey = state.depositos
            .findIndex(item => item == deposito);

        if (itemKey != -1) {
            state.depositos.splice(itemKey, 1);
        }

        if (state.depositos.lenght != 0) {
            state.importeDepositos = state.depositos
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeDepositos = 0;
        }
    },

    'SET_TRANSFERENCIA' (state, transferencia) {
        state.transferencias.push(transferencia);

        if (state.transferencias.lenght != 0) {
            state.importeTransferencias = state.transferencias
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeTransferencias = 0;
        }
    },
    'DELETE_TRANSFERENCIA' (state, transferencia) {
        let itemKey = state.transferencias
            .findIndex(item => item == transferencia);

        if (itemKey != -1) {
            state.transferencias.splice(itemKey, 1);
        }

        if (state.transferencias.lenght != 0) {
            state.importeTransferencias = state.transferencias
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeTransferencias = 0;
        }
    },

    'INICIALIZAR_DATOS' (state) {
        state.ingresoEgresoDatos = [];
        state.ingresoEgresoCuotasDatos = [];
        state.ingresoEgresoDocumentos = [];
        state.ingresoEgresoDepositos = [];
        state.ingresoEgresoDatosRpt = [];
    },
    'SET_INGRESO_EGRESO_DATOS' (state, params) {
        state.ingresoEgresoDatos = params.ingresoEgresoDatos;
        state.ingresoEgresoCuotasDatos = params.ingresoEgresoCuotasDatos;
        state.ingresoEgresoDocumentos = params.ingresoEgresoDocumentos;
        state.ingresoEgresoTransferencias = params.ingresoEgresoTransferencias;
        state.ingresoEgresoDepositos = params.ingresoEgresoDepositos;
        state.ingresoEgresoDatosRpt = params.ingresoEgresoDatosRpt;
        
        /* Sumarizamos los documentos */
        if (state.ingresoEgresoDatosRpt) {
            let importeDocumentos = 0;
            let importeDepositos = 0;
            let importeTransferencias = 0;

            if (state.ingresoEgresoDatosRpt.documentos.lenght != 0) {
                importeDocumentos = state.ingresoEgresoDatosRpt.documentos
                    .reduce((a, b) => a + b.importe, 0);
            }

            if (state.ingresoEgresoDatosRpt.depositos.lenght != 0) {
                importeDepositos = state.ingresoEgresoDatosRpt.depositos
                    .reduce((a, b) => a + b.importe, 0);
            }

            if (state.ingresoEgresoDatosRpt.transferencias.lenght != 0) {
                importeTransferencias = state.ingresoEgresoDatosRpt.transferencias
                    .reduce((a, b) => a + b.importe, 0);
            }

            state.ingresoEgresoDatosRpt.importeDocumentos = importeDocumentos;
            state.ingresoEgresoDatosRpt.importeDepositos = importeDepositos;
            state.ingresoEgresoDatosRpt.importeTransferencias = importeTransferencias;
        }
    },
};

const getters = {
    getField,

    totalDocumentos(state) {
        return getTotalDocumentos(state);
    },

    ingresoEgresoDatosRpt(state) {
        return state.ingresoEgresoDatosRpt;
    },
};

function inicializarDocumentos(state) {
    state.pesos = 0;
    state.depositos = [];
    state.importeDepositos = 0;
    state.transferencias = [];
    state.importeTransferencias = 0;
}

function getTotalDocumentos(state) {
    return parseFloat(state.pesos)
        + parseFloat(state.importeDepositos)
        + parseFloat(state.importeTransferencias);
}

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INGRESO_EGRESO');
            
             /* Recuperamos la caja central */
            apiAxios.get('cajas/central')
                .then((res) => {
                    commit("SET_CAJA_REGISTRO", res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';

            let totalDocumentos = getTotalDocumentos(state);

            if (totalDocumentos == 0) {
                save = false;
                errorMessage = "El total del movimiento no puede ser igual a cero."
            }

            let cuotas = [];
            if (state.cuotas) {
                cuotas = state.cuotas.map(cuota => ({
                    periodo: moment.utc(cuota.periodo).format('YYYY-MM-DD'),
                    importe: parseFloat(cuota.importe),
                    observaciones: cuota.observaciones
                }))
            }

            if (save) {
                let ingresoEgreso= {
                    personalId: parseInt(state.personalId),
                    ingresoEgresoTipoId: parseInt(state.ingresoEgresoTipoId),
                    observaciones: state.observaciones.trim(),

                    cuotas,

                    pesos: parseFloat(state.pesos),
                    depositos: state.depositos.map(deposito => ({
                        fechaCreditoDebito: moment(deposito.fechaCreditoDebito).format('YYYY-MM-DD'),
                        bancoCuentaId: parseInt(deposito.bancoCuentaId),
                        importe: parseInt(deposito.importe)
                    })),
                    transferencias: state.transferencias.map(transferencia => ({
                        fechaCreditoDebito: moment(transferencia.fechaCreditoDebito).format('YYYY-MM-DD'),
                        bancoCuentaId: parseInt(transferencia.bancoCuentaId),
                        importe: parseInt(transferencia.importe)
                    })),

                    cajaRegistroId: state.cajaRegistroId,
                };

                let url = 'ingresosegresos';

                apiAxios.post(url, ingresoEgreso)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    setPersonal: ({ commit }, personal) => {
        commit('SET_PERSONAL', personal);
    },
    setIngresoEgresoTipo: ({ commit }, ingresoEgresoTipo) => {
        commit('SET_INGRESO_EGRESO_TIPO', ingresoEgresoTipo);
    },
    addCuota ( { commit }, cuota ) {
        commit('ADD_CUOTA', cuota);
    },
    deleteCuota ( { commit }, cuota) {
        commit('DELETE_CUOTA', cuota);
    },
    setCajaRegistro ( { commit }, cajaRegistro ) {
        commit('SET_CAJA_REGISTRO', cajaRegistro);
    },
    setDeposito ( { commit }, deposito ) {
        commit('SET_DEPOSITO', deposito);
    },
    deleteDeposito ( { commit }, deposito) {
        commit('DELETE_DEPOSITO', deposito);
    },
    setTransferencia ( { commit }, transferencia ) {
        commit('SET_TRANSFERENCIA', transferencia);
    },
    deleteTransferencia ( { commit }, transferencia) {
        commit('DELETE_TRANSFERENCIA', transferencia);
    },
    getDatos ( { commit }, ingresoEgresoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (ingresoEgresoId) {
                apiAxios.get('ingresosegresos/' + ingresoEgresoId ) 
                    .then(res => {
                        let ingresoEgresoDatos = [
                            { 'nombre': 'id', 'campo': 'Nro. Orden', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'fechaComprobante', 'campo': 'Fecha', 'valor': res.data.fechaComprobante, 'formato': 'fecha' },
                            // { 'nombre': 'fechaContable', 'campo': 'Fecha Contable', 'valor': res.data.fechaContable, 'formato': 'fecha' },
                            { 'nombre': 'personal', 'campo': 'Personal', 'valor': res.data.personal, 'formato': '' },
                            { 'nombre': 'ingresoEgresoTipo', 'campo': 'Tipo', 'valor': res.data.ingresoEgresoTipo, 'formato': '' },
                            { 'nombre': 'total', 'campo': 'Total', 'valor': res.data.total, 'formato': 'moneda' },
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones.trim(), 'formato': '' },
                        ]

                        let params = {
                            ingresoEgresoDatos,
                            ingresoEgresoCuotasDatos: res.data.cuotas,
                            ingresoEgresoDocumentos: res.data.documentos,
                            ingresoEgresoDepositos: res.data.depositos,
                            ingresoEgresoTransferencias: res.data.transferencias,
                            ingresoEgresoDatosRpt: res.data
                        }
                                      
                        commit('SET_INGRESO_EGRESO_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}